/* ============================================================
   Faboriq custom scripts
   - Wishlist (localStorage) + header count
   - Product card quick add / size select add-to-cart
   ============================================================ */
(function () {
  'use strict';

  var WISHLIST_KEY = 'faboriq:wishlist';

  /* ---------------- Wishlist store ---------------- */
  var Wishlist = {
    read: function () {
      try {
        return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      } catch (e) {
        return [];
      }
    },
    write: function (items) {
      try {
        localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
      } catch (e) {
        /* storage unavailable */
      }
      Wishlist.updateBadges();
      document.dispatchEvent(new CustomEvent('faboriq:wishlist:changed'));
    },
    has: function (handle) {
      return Wishlist.read().some(function (item) {
        return item.handle === handle;
      });
    },
    toggle: function (entry) {
      var items = Wishlist.read();
      var exists = items.some(function (item) {
        return item.handle === entry.handle;
      });
      if (exists) {
        items = items.filter(function (item) {
          return item.handle !== entry.handle;
        });
      } else {
        items.unshift(entry);
      }
      Wishlist.write(items);
      return !exists;
    },
    remove: function (handle) {
      Wishlist.write(
        Wishlist.read().filter(function (item) {
          return item.handle !== handle;
        })
      );
    },
    updateBadges: function () {
      var count = Wishlist.read().length;
            document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
        var iconLink = el.closest('.header__icon--wishlist');
        if (iconLink) iconLink.classList.toggle('wishlist-has-items', count > 0);
      });
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        var saved = Wishlist.has(btn.dataset.handle);
        btn.classList.toggle('is-saved', saved);
        btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      });
    }
  };
  window.FaboriqWishlist = Wishlist;

  /* ---------------- Cart helper ---------------- */
  function addVariantToCart(variantId) {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { id: variantId, quantity: 1 };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) {
        return s.id;
      });
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'Could not add to cart');
        if (cart && typeof cart.renderContents === 'function') {
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        }
        document.dispatchEvent(new CustomEvent('faboriq:cart:added', { detail: data }));
        return data;
      });
  }
  window.FaboriqAddToCart = addVariantToCart;

  /* ---------------- Delegated events ---------------- */
  document.addEventListener('click', function (event) {
    /* Wishlist toggle */
    var wishBtn = event.target.closest('[data-wishlist-toggle]');
    if (wishBtn) {
      event.preventDefault();
      event.stopPropagation();
      Wishlist.toggle({
        handle: wishBtn.dataset.handle,
        url: wishBtn.dataset.url,
        title: wishBtn.dataset.title,
        image: wishBtn.dataset.image,
        price: wishBtn.dataset.price
      });
      return;
    }
       /* Mobile quick shop toggle */
    var toggleBtn = event.target.closest('[data-quick-shop-toggle]');
    if (toggleBtn) {
      event.preventDefault();
      event.stopPropagation();
      var inner = toggleBtn.closest('.card__inner');
      var panel = inner ? inner.querySelector('.card-quick-shop') : null;
      if (panel) {
        var isOpen = panel.classList.toggle('is-open');
        toggleBtn.classList.toggle('is-open', isOpen);
        toggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        document.querySelectorAll('.card-quick-shop.is-open').forEach(function (p) {
          if (p !== panel) {
            p.classList.remove('is-open');
            var otherInner = p.closest('.card__inner');
            var otherToggle = otherInner ? otherInner.querySelector('[data-quick-shop-toggle]') : null;
            if (otherToggle) {
              otherToggle.classList.remove('is-open');
              otherToggle.setAttribute('aria-expanded', 'false');
            }
          }
        });
      }
      return;
    }

    /* Tap outside an open quick shop panel closes it */
    if (!event.target.closest('.card-quick-shop')) {
      document.querySelectorAll('.card-quick-shop.is-open').forEach(function (p) {
        p.classList.remove('is-open');
        var pInner = p.closest('.card__inner');
        var pToggle = pInner ? pInner.querySelector('[data-quick-shop-toggle]') : null;
        if (pToggle) {
          pToggle.classList.remove('is-open');
          pToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }
    /* Quick add (single variant or chosen size) */
    var atcBtn = event.target.closest('[data-quick-atc]');
    if (atcBtn && !atcBtn.disabled) {
      event.preventDefault();
      event.stopPropagation();
      var panel = atcBtn.closest('.card-quick-shop');
      var feedback = panel ? panel.querySelector('[data-quick-feedback]') : null;
      atcBtn.classList.add('is-loading');
      atcBtn.disabled = true;
      addVariantToCart(atcBtn.dataset.quickAtc)
        .then(function () {
          if (feedback) feedback.textContent = atcBtn.dataset.addedMessage || 'Added!';
        })
        .catch(function (err) {
          if (feedback) feedback.textContent = err.message;
        })
        .finally(function () {
          atcBtn.classList.remove('is-loading');
          atcBtn.disabled = false;
          if (feedback) {
            setTimeout(function () {
              feedback.textContent = '';
            }, 2500);
          }
        });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', Wishlist.updateBadges);
  } else {
    Wishlist.updateBadges();
  }
})();
